<template>
    <div class="navigation">
        <div class="left-class">
            <span>{{ classInfo.course_name }}</span>
            <el-button v-if="classInfo.cate == 1" type="primary" icon="el-icon-edit" size="small" @click="assignWork">
                <i></i> 布置作业</el-button>
        </div>
        <div class="right-filter">
            <el-select v-if="classInfo.cate == 2" size="small" placeholder="请选择课程" v-model="courseId"
                @change="courseChange">
                <el-option v-for="item in classInfo.courses" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-input size="small" v-model="keyword" placeholder="请输入关键词搜索" @keyup.enter.native="handleEnter">
                <i v-if="keyword.length > 0" slot="suffix" class="el-icon-circle-close" @click="clearKeyword"></i>
                <i slot="suffix" class="el-icon-search" @click="keywordSearch"></i>
            </el-input>
            <slot></slot>
            <!-- <el-date-picker size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="date" placeholder="请选择日期"
                :picker-options="pickerOptions" @change="dateChange"></el-date-picker> -->
            <el-button size="small" @click="toStatistics">统计 <i class="el-icon-right"></i></el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            // lesson:'', //当前课程
            keyword: '',
            date: '',
            courseId: this.$store.state.classInfo.course_id,
            // class_id: localStorage.getItem("class_id"), // 班级id
            // cate:localStorage.getItem('cate'), // 角色分类
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now()
                },
            },
        }
    },
    computed: {
        ...mapState({
            lesson: state => state.lesson,
            // cate: state => state.cate,
            classInfo: state => state.classInfo,
        }),
    },

    watch: {
        'classInfo.course_id' (val) {
            this.courseId = val
        }
    },

    mounted () {
        // const {lesson} = JSON.parse(localStorage.getItem('vuex'))
        // this.lesson = lesson
        // if(this.classInfo.cate == 2) {
        // this.getCourseInfo()

        // }
    },
    methods: {
        // 选择日期
        dateChange (val) {
            this.date = val !== null ? val : ''
            this.$emit('dateChange', this.date)
        },
        // 关键字搜索
        handleEnter () {
            this.$emit('keywordSearch', this.keyword)
        },
        keywordSearch () {
            this.$emit('keywordSearch', this.keyword)
        },
        clearKeyword () {
            this.keyword = ''
            this.$emit('keywordSearch', this.keyword)
        },
        // 布置作业
        assignWork () {
            this.$emit('assignWork')
        },
        // 获取课程信息
        async getCourseInfo () {
            const { data: res } = await this.$axios.post('base/class/list', {
                class_id: this.class_id,
            })

            if (res.errCode === 0) {
                const info = res.data.map(item => {
                    return {
                        course_id: item.course_id,
                        course_name: item.course_name
                    }
                })
                this.option = info

            }
        },
        courseChange () {
            this.$emit('courseChange', this.courseId)
        },
        // 跳转作业统计详情页
        toStatistics () {
            // const cate = localStorage.getItem("cate")
            this.$router.push('/statistics')
            // if(cate == 1) {

            // }else {
            //     this.$router.push('/studentStatistic')
            // }

        }
    },

}
</script>

<style lang="scss" scoped>
.navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #d8e2eb;

    .left-class {
        span {
            position: relative;
            margin-left: 10px;
            font-weight: 600;
            margin-right: 40px;

            &::before {
                content: '';
                position: absolute;
                top: 8px;
                display: block;
                width: 6px;
                height: 6px;
                // margin:0 15px 0 0;
                border-radius: 50%;
                background: #DA6013;

            }
        }
    }

    .right-filter {
        display: flex;
        align-items: center;

        &>* {
            margin-left: 10px;
        }

        .el-input {
            width: 220px;
        }

        .el-button {
            color: #2881CD;
            background: rgba($color: #2881CD, $alpha: 0.12);
        }

        /deep/ .el-icon-search,
        .el-icon-circle-close {
            width: 24px;
            height: 24px;
            line-height: 32px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/list/Navigation.vue